import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'uz',
    fallbackLng: 'uz',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${import.meta.env.VITE_BOT_BACKEND_URL}/i18n/{{lng}}/{{ns}}`,
    },
  });

export default i18n;
